import React, { useState, useEffect } from "react";
import { Auth } from "aws-amplify";
import { useNavigate, useLocation } from "react-router-dom";
import { LambdaClient, InvokeCommand } from "@aws-sdk/client-lambda";
import { jwtDecode } from "jwt-decode";
import { Modal, Button } from "react-bootstrap";
import { useLoading } from "../../context/LoadingContext";
import config from "../../aws-exports";
import "../../styles/general.css";
import "../../styles/buyer.css";
//import SidebarBuyer from "../../pages/Requirement/components/layout/BuyerSidebar";
import Header from "../../pages/Requirement/components/layout/Header";
import SidebarBuyer from "../../pages/Requirement/components/layout/BuyerSidebar";
const BuyerDashboard = () => {
  const location = useLocation();
  const initialFilter = location.state?.selectedFilter || "All Offers";
  const [queryDescription, setQueryDescription] = useState("");
  const [selectedFilter, setSelectedFilter] = useState(initialFilter); // Use initialFilter
  const [activeTab, setActiveTab] = useState("basicInfo");
  const [activeUser, setActiveUser] = useState("");
  const [buyerItemDetails, setBuyerItemDetails] = useState([]);
  const [queries, setQueries] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [queryPage, setQueryPage] = useState(1);
  const [queryTotalPages, setQueryTotalPages] = useState(1);
  const [selectedBuyerItemDetail, setSelectedBuyerItemDetail] = useState(null);
  const [selectedQuery, setSelectedQuery] = useState(null);
  const [products, setProducts] = useState([]);
  const [states, setStates] = useState([]);
  const [filterTerms, setFilterTerms] = useState({
    product: "",
    grade: "",
    state: "",
  });
  const [showModal, setShowModal] = useState(false);
  const [showModalMsg, setShowModalMsg] = useState("");
  const [showRaiseQueryModal, setShowRaiseQueryModal] = useState(false);
  const navigate = useNavigate();
  const pageSize = 10;
  const queryPageSize = 5;
  const { setLoading } = useLoading();

  const getBackendName = () => {
    const backend = config.aws_user_files_s3_bucket.split("-");
    return backend[backend.length - 1];
  };

  const fetchBuyerItems = async () => {
    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true,
      });

      const body = {
        target: "listBuyerItemDetails",
        access_token: user.signInUserSession.idToken.jwtToken,
        filterTerms,
        rowStart: (currentPage - 1) * pageSize,
        pageSize: pageSize,
      };

      const params = {
        FunctionName: `backendops-${getBackendName()}`,
        Payload: JSON.stringify({ body }),
      };

      const command = new InvokeCommand(params);
      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));
      if (result.statusCode === 200) {
        result = JSON.parse(result.body);
        setBuyerItemDetails(result.items);
        setTotalPages(Math.ceil(result.total / pageSize));
        if (result.items.length > 0) {
          setSelectedBuyerItemDetail(result.items[0]);
        }
      } else {
        console.error("Error fetching buyerItemDetails: ", result);
      }
    } catch (error) {
      console.error("Error invoking Lambda function: ", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchQueries = async () => {
    if (!selectedBuyerItemDetail) {
      console.error("No client selected");
      return;
    }
    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });
      const user = await Auth.currentAuthenticatedUser({ bypassCache: true });

      const body = {
        target: "listAmtplQueries",
        access_token: user.signInUserSession.idToken.jwtToken,
        filterTerms: { BuyerItemID: selectedBuyerItemDetail.BuyerItemID },
        rowStart: (queryPage - 1) * queryPageSize,
        pageSize: queryPageSize,
      };

      const params = {
        FunctionName: `dataops-${getBackendName()}`,
        Payload: JSON.stringify({ body }),
      };

      const command = new InvokeCommand(params);
      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));
      if (result.statusCode === 200) {
        result = JSON.parse(result.body);
        setQueries(result.items);
        setQueryTotalPages(Math.ceil(result.total / queryPageSize));
        if (result.items.length > 0) {
          setSelectedQuery(result.items[0]);
        }
      } else {
        console.error("Error fetching queries: ", result);
      }
    } catch (error) {
      console.error("Error invoking Lambda function: ", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateQuery = async () => {
    if (!queryDescription) {
      console.error("Query Description is required");
      return;
    }

    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });
      const user = await Auth.currentAuthenticatedUser({ bypassCache: true });

      const body = {
        target: "createAmtplQuery",
        access_token: user.signInUserSession.idToken.jwtToken,
        createAmtplQueryInput: {
          BuyerItemID: selectedBuyerItemDetail.BuyerItemID,
          QueryDescription: queryDescription,
          BuyerEmailID: user.attributes.email,
          QueryType: "Buyer",
        },
      };

      const params = {
        FunctionName: `dataops-${getBackendName()}`,
        Payload: JSON.stringify({ body }),
      };

      const command = new InvokeCommand(params);
      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));

      if (result.statusCode === 200) {
        console.log("Query creation successful", result);
        setShowModalMsg("Query creation successful");
        setShowModal(true);
        // Fetch the updated queries
        fetchQueries();
      } else {
        console.error("Error creating query: ", result);
        setShowModalMsg("Error creating query");
        setShowModal(true);
      }
    } catch (error) {
      console.error("Error invoking Lambda function: ", error);
      setShowModalMsg("Error creating query");
      setShowModal(true);
    } finally {
      setLoading(false);
      setShowRaiseQueryModal(false); // Close the modal after handling the query creation
      setQueryDescription(""); // Clear the query description
    }
  };

  useEffect(() => {
    const checkUser = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        const decodedToken = jwtDecode(token);

        // Check if the user is a member of the AMTPL_BUYERS group
        const groups = decodedToken["cognito:groups"] || [];
        if (!groups.includes("AMTPL_BUYERS")) {
          await Auth.signOut(); // Sign out the user
          navigate("/login/buyer");
        } else {
          setActiveUser(user.attributes.email); // Set the active user email
        }
      } catch (error) {
        await Auth.signOut(); // Sign out the user
        navigate("/login/buyer");
      }
    };

    checkUser();
    fetchBuyerItems();
    fetchProducts();
    fetchStates();
    if (activeTab === "queries") {
      fetchQueries();
    }
  }, [
    navigate,
    currentPage,
    queryPage,
    setLoading,
    filterTerms,
    selectedFilter,
  ]);

  const fetchProducts = async () => {
    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });

      const user = await Auth.currentAuthenticatedUser();
      const token = user.signInUserSession.idToken.jwtToken;
      const backendName = getBackendName();

      const command = new InvokeCommand({
        FunctionName: `dataops-${backendName}`,
        Payload: JSON.stringify({
          body: {
            target: "listProducts",
            access_token: token,
            rowStart: 0,
            pageSize: 100,
          },
        }),
      });

      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));
      if (result.statusCode === 200) {
        result = JSON.parse(result.body);
        setProducts(result.items);
      } else {
        console.error("Error fetching products: ", result);
      }
    } catch (error) {
      console.error("Error fetching products", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchStates = async () => {
    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });

      const user = await Auth.currentAuthenticatedUser();
      const token = user.signInUserSession.idToken.jwtToken;
      const backendName = getBackendName();

      const command = new InvokeCommand({
        FunctionName: `dataops-${backendName}`,
        Payload: JSON.stringify({
          body: {
            target: "listDynamicDropDownOptions",
            option: "buyeritemstates",
            access_token: token,
            rowStart: 0,
            pageSize: 100,
          },
        }),
      });

      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));
      if (result.statusCode === 200) {
        result = JSON.parse(result.body);
        setStates(result.items.map((option) => option.result));
      } else {
        console.error(`Error fetching $States : ${JSON.stringify(result)}`);
      }
    } catch (error) {
      console.error(`Error fetching States: ${JSON.stringify(error)}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (activeTab === "queries") {
      fetchQueries();
    }
  }, [selectedBuyerItemDetail]);

  const handleSignOut = async () => {
    setLoading(true);
    try {
      await Auth.signOut();
      navigate("/login/buyer");
    } catch (error) {
      console.error("Error signing out: ", error);
    } finally {
      setLoading(false);
    }
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    if (tab === "queries") {
      fetchQueries();
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleQueryPageChange = (newPage) => {
    if (newPage > 0 && newPage <= queryTotalPages) {
      setQueryPage(newPage);
    }
  };

  const handleRowClick = (buyerItemDetail) => {
    setSelectedBuyerItemDetail(buyerItemDetail);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilterTerms((prevTerms) => ({ ...prevTerms, [name]: value }));
    resetFilter();
  };

  const handleSearch = () => {
    resetFilter();
  };

  const handleReset = () => {
    setFilterTerms({ product: "", grade: "" });
    const selectedValue = selectedFilter;
    if (selectedValue === "All Offers") {
      setFilterTerms((prevTerms) => ({
        ...prevTerms,
        IsShortlist: "",
        IsQueried: "",
        IsBAFO: "",
      }));
    } else if (selectedValue === "Shortlisted Offers") {
      setFilterTerms((prevTerms) => ({
        ...prevTerms,
        IsShortlist: 1,
        IsQueried: "",
        IsBAFO: "",
      }));
    } else if (selectedValue === "Queried Offers") {
      setFilterTerms((prevTerms) => ({
        ...prevTerms,
        IsShortlist: "",
        IsQueried: 1,
        IsBAFO: "",
      }));
    } else if (selectedValue === "BAFO") {
      setFilterTerms((prevTerms) => ({
        ...prevTerms,
        IsShortlist: "",
        IsQueried: "",
        IsBAFO: 1,
      }));
    }
    resetFilter();
  };

  const handleQueryRowClick = (query) => {
    setSelectedQuery(query);
  };

  const handleAction = async (status) => {
    if (!selectedBuyerItemDetail) {
      console.error("No client selected");
      return;
    }

    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });
      const user = await Auth.currentAuthenticatedUser({ bypassCache: true });

      let target;
      if (status === "Shortlist") {
        target = "buyerShortlistOffer";
      } else if (status === "Callback") {
        target = "buyerCallback";
      } else if (status === "BAFO") {
        target = "buyerSendBAFO";
      } else {
        console.error("Invalid status");
        setLoading(false);
        return;
      }

      const body = {
        target: target,
        access_token: user.signInUserSession.idToken.jwtToken,
        BuyerItemExtendedInput: {
          BuyerItemID: selectedBuyerItemDetail.BuyerItemID,
          OfferStatus: status,
          GPEmailID: user.attributes.email,
        },
      };

      const params = {
        FunctionName: `backendops-${getBackendName()}`, // Updated to backendops
        Payload: JSON.stringify({ body }),
      };

      const command = new InvokeCommand(params);
      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));

      if (result.statusCode === 200) {
        console.log(`${status} action successful`, result);
        setShowModalMsg(`${status} action successful`);
        setShowModal(true);
      } else {
        console.error(`Error updating GPOffer ${JSON.stringify(result)}`);
        setShowModalMsg(`Error updating GPOffer ${JSON.stringify(result)}`);
        setShowModal(true);
      }
    } catch (error) {
      console.error(`Error updating GPOffer ${JSON.stringify(error)}`);
      setShowModalMsg(`Error updating GPOffer ${JSON.stringify(error)}`);
      setShowModal(true);
    } finally {
      setLoading(false);
    }
  };

  const handleShortlist = () => handleAction("Shortlist");

  const handleCallback = () => handleAction("Callback");

  const handleSendBAFO = () => handleAction("BAFO");

  const resetFilter = () => {
    setSelectedBuyerItemDetail(null);
    setCurrentPage(1);
    setSelectedQuery(null);
    setQueryPage(1);
    setQueries([]);
  };

  const handleDataFilterChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedFilter(selectedValue);
    if (selectedValue === "All Offers") {
      setFilterTerms((prevTerms) => ({
        ...prevTerms,
        IsShortlist: "",
        IsQueried: "",
        IsBAFO: "",
      }));
      resetFilter();
    } else if (selectedValue === "Shortlisted Offers") {
      setFilterTerms((prevTerms) => ({
        ...prevTerms,
        IsShortlist: 1,
        IsQueried: "",
        IsBAFO: "",
      }));
      resetFilter();
    } else if (selectedValue === "Queried Offers") {
      setFilterTerms((prevTerms) => ({
        ...prevTerms,
        IsShortlist: "",
        IsQueried: 1,
        IsBAFO: "",
      }));
      resetFilter();
    } else if (selectedValue === "BAFO") {
      setFilterTerms((prevTerms) => ({
        ...prevTerms,
        IsShortlist: "",
        IsQueried: "",
        IsBAFO: 1,
      }));
      resetFilter();
    } else if (selectedValue === "Requirement") {
      redirectRequirement();
    }
  };
  const redirectRequirement = () => {
    navigate("/requirement");
  };
  return (
    <div className="buyer-dashboard">
      <Header activeUser={activeUser} setLoading={setLoading} />
      <div className="content">
         <SidebarBuyer selectedFilter={selectedFilter}
            handleDataFilterChange={handleDataFilterChange}/>
          <main className="main-content">
          <div className="offers-search row">
            <div className="col-lg-3 col-sm-4 col-6">
              <select
                className="form-control form-select"
                id="product"
                name="product"
                value={filterTerms.product || ""}
                onChange={handleFilterChange}
              >
                <option value="">Select a product</option>
                {[
                  ...new Set(products.map((product) => product.ProductName)),
                ].map((product) => (
                  <option key={product} value={product}>
                    {product}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-lg-3 col-sm-4 col-6">
              <select
                className="form-control form-select"
                id="grade"
                name="grade"
                value={filterTerms.grade || ""}
                onChange={handleFilterChange}
              >
                <option value="">Select a Grade</option>
                {products
                  .filter(
                    (product) => product.ProductName === filterTerms.product
                  )
                  .map((product) => (
                    <option key={product.Grade} value={product.Grade}>
                      {product.Grade}
                    </option>
                  ))}
              </select>
            </div>
            <div className="col-lg-3 col-sm-4 col-6">
              <select
                className="form-control form-select"
                id="state"
                name="state"
                value={filterTerms.state || ""}
                onChange={handleFilterChange}
              >
                <option value="">Select State</option>
                {states.map((state) => (
                  <option key={state} value={state}>
                    {state}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-lg-3 col-sm-4 col-6">
              <button onClick={handleSearch} className="mx-3 d-inline">
                Search
              </button>
              <button onClick={handleReset} className="d-inline">
                Reset
              </button>
            </div>
          </div>

          <section className="offers">
            <table>
              <thead>
                <tr>
                  <th>Product</th>
                  <th>Grade</th>
                  <th>Quantity</th>
                  <th>Price</th>
                  <th>Country</th>
                  <th>INCO</th>
                  <th>Expires</th>
                </tr>
              </thead>
              <tbody>
                {buyerItemDetails.map((buyerItemDetail) => (
                  <tr
                    key={buyerItemDetail.BuyerItemID}
                    onClick={() => handleRowClick(buyerItemDetail)}
                    className={
                      selectedBuyerItemDetail &&
                      selectedBuyerItemDetail.BuyerItemID ===
                        buyerItemDetail.BuyerItemID
                        ? "selected"
                        : ""
                    }
                  >
                    <td>{buyerItemDetail.ProductName}</td>
                    <td>{buyerItemDetail.Grade}</td>
                    <td>{buyerItemDetail.Quantity}</td>
                    <td>{buyerItemDetail.Price}</td>
                    <td>{buyerItemDetail.Country}</td>
                    <td>{buyerItemDetail.INCO}</td>
                    <td>{buyerItemDetail.Expires}</td>
                  </tr>
                ))}
                {buyerItemDetails.length === 0 && (
                  <tr>
                    <td colSpan="7">No Buyer items available</td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="pagination">
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                {"<"}
              </button>
              {Array.from({ length: totalPages }, (_, index) => (
                <button
                  key={index + 1}
                  onClick={() => handlePageChange(index + 1)}
                  className={currentPage === index + 1 ? "active" : ""}
                >
                  {index + 1}
                </button>
              ))}
              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                {">"}
              </button>
            </div>
          </section>

          <section className="product-details">
            <div className="tabs">
              <button
                className={activeTab === "basicInfo" ? "active" : ""}
                onClick={() => handleTabClick("basicInfo")}
              >
                Basic Info
              </button>
              <button
                className={activeTab === "specifications" ? "active" : ""}
                onClick={() => handleTabClick("specifications")}
              >
                Specifications
              </button>
              <button
                className={activeTab === "pricing" ? "active" : ""}
                onClick={() => handleTabClick("pricing")}
              >
                Pricing
              </button>
              <button
                className={activeTab === "shipping" ? "active" : ""}
                onClick={() => handleTabClick("shipping")}
              >
                Shipping
              </button>
              <button
                className={activeTab === "queries" ? "active" : ""}
                onClick={() => handleTabClick("queries")}
              >
                Queries
              </button>
            </div>

            {activeTab === "basicInfo" && selectedBuyerItemDetail && (
              <div className="tab-content active">
                <div className="row">
                  <div className="col-lg-9 col-sm-9 col-6">
                    <div className="row">
                      <div className="col-lg-3 col-sm-4 col-6">
                        <label>Product</label>
                        <input
                          type="text"
                          readOnly
                          value={selectedBuyerItemDetail.ProductName}
                          className="form-control"
                        />
                      </div>
                      <div className="col-lg-3 col-sm-4 col-6">
                        <label>Grade</label>
                        <input
                          type="text"
                          readOnly
                          value={selectedBuyerItemDetail.Grade}
                          className="form-control"
                        />
                      </div>
                      <div className="col-lg-3 col-sm-4 col-6">
                        <label>Quantity</label>
                        <input
                          type="text"
                          readOnly
                          value={selectedBuyerItemDetail.Quantity}
                          className="form-control"
                        />
                      </div>
                      <div className="col-lg-3 col-sm-4 col-6">
                        <label>Price</label>
                        <input
                          type="text"
                          readOnly
                          value={selectedBuyerItemDetail.Price}
                          className="form-control"
                        />
                      </div>
                      <div className="col-lg-3 col-sm-4 col-6">
                        <label>State</label>
                        <input
                          type="text"
                          readOnly
                          value={selectedBuyerItemDetail.State}
                          className="form-control"
                        />
                      </div>
                      <div className="col-lg-3 col-sm-4 col-6">
                        <label>Country</label>
                        <input
                          type="text"
                          readOnly
                          value={selectedBuyerItemDetail.Country}
                          className="form-control"
                        />
                      </div>
                      <div className="col-lg-3 col-sm-4 col-6">
                        <label>INCO</label>
                        <input
                          type="text"
                          readOnly
                          value={selectedBuyerItemDetail.INCO}
                          className="form-control"
                        />
                      </div>
                      <div className="col-lg-3 col-sm-4 col-6">
                        <label>Expires</label>
                        <input
                          type="text"
                          readOnly
                          value={selectedBuyerItemDetail.Expires}
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-3 col-6">
                    <div className="actions">
                      <div className="row">
                        <div className="col-12 mb-2">
                          <button onClick={handleShortlist}>Shortlist</button>
                        </div>
                        <div className="col-12 mb-2">
                          <button onClick={handleCallback}>Call Back</button>
                        </div>
                        <div className="col-12 mb-2">
                          <button onClick={handleSendBAFO}>Send BAFO</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "specifications" && selectedBuyerItemDetail && (
              <div className="tab-content active">
                <div className="row">
                  <div className="col-lg-9 col-sm-9 col-6">
                    <div className="row">
                      <label htmlFor="productSpecifications">
                        Product Specifications
                      </label>
                      <textarea
                        id="productSpecifications"
                        name="productSpecifications"
                        maxLength="4000"
                        className="form-control"
                        rows="10"
                        value={selectedBuyerItemDetail?.productSpecifications}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-3 col-6">
                    <div className="actions">
                      <div className="row">
                        <div className="col-12 mb-2">
                          <button onClick={handleShortlist}>Shortlist</button>
                        </div>
                        <div className="col-12 mb-2">
                          <button onClick={handleCallback}>Call Back</button>
                        </div>
                        <div className="col-12 mb-2">
                          <button onClick={handleSendBAFO}>Send BAFO</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "pricing" && selectedBuyerItemDetail && (
              <div className="tab-content active">
                <div className="row">
                  <div className="col-lg-9 col-sm-9 col-6">
                    <div className="row">
                      <div className="col-lg-3 col-sm-4 col-6">
                        <label>Currency</label>
                        <input
                          type="text"
                          readOnly
                          value={selectedBuyerItemDetail.Currency}
                          className="form-control"
                        />
                      </div>
                      <div className="col-lg-3 col-sm-4 col-6">
                        <label>Price / MT</label>
                        <input
                          type="text"
                          readOnly
                          value={selectedBuyerItemDetail.Price}
                          className="form-control"
                        />
                      </div>
                      <div className="col-lg-3 col-sm-4 col-6">
                        <label>Total Price</label>
                        <input
                          type="text"
                          readOnly
                          value={
                            selectedBuyerItemDetail.Price *
                            selectedBuyerItemDetail.Quantity
                          }
                          className="form-control"
                        />
                      </div>
                      <div className="col-lg-3 col-sm-4 col-6">
                        <label>Price Type</label>
                        <input
                          type="text"
                          readOnly
                          value={selectedBuyerItemDetail.PriceType}
                          className="form-control"
                        />
                      </div>
                      <div className="col-lg-3 col-sm-4 col-6">
                        <label>Payment</label>
                        <input
                          type="text"
                          readOnly
                          value={selectedBuyerItemDetail.Payment}
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-3 col-6">
                    <div className="actions">
                      <div className="row">
                        <div className="col-12 mb-2">
                          <button onClick={handleShortlist}>Shortlist</button>
                        </div>
                        <div className="col-12 mb-2">
                          <button onClick={handleCallback}>Call Back</button>
                        </div>
                        <div className="col-12 mb-2">
                          <button onClick={handleSendBAFO}>Send BAFO</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "shipping" && selectedBuyerItemDetail && (
              <div className="tab-content active">
                <div className="row">
                  <div className="col-lg-9 col-sm-9 col-6">
                    <div className="row">
                      <div className="col-lg-3 col-sm-4 col-6">
                        <label>Loading Port</label>
                        <input
                          type="text"
                          readOnly
                          value={selectedBuyerItemDetail.LoadingPort}
                          className="form-control"
                        />
                      </div>
                      <div className="col-lg-3 col-sm-4 col-6">
                        <label>Loading Date</label>
                        <input
                          type="text"
                          readOnly
                          value={selectedBuyerItemDetail.LoadingDate}
                          className="form-control"
                        />
                      </div>
                      <div className="col-lg-3 col-sm-4 col-6">
                        <label>Discharge Port</label>
                        <input
                          type="text"
                          readOnly
                          value={selectedBuyerItemDetail.DischargePort}
                          className="form-control"
                        />
                      </div>
                      <div className="col-lg-3 col-sm-4 col-6">
                        <label>Discharge Date</label>
                        <input
                          type="text"
                          readOnly
                          value={selectedBuyerItemDetail.DischargeDate}
                          className="form-control"
                        />
                      </div>
                      <div className="col-lg-3 col-sm-4 col-6">
                        <label>Discharge Quantity</label>
                        <input
                          type="text"
                          readOnly
                          value={selectedBuyerItemDetail.DischargeQty}
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-3 col-6">
                    <div className="actions">
                      <div className="row">
                        <div className="col-12 mb-2">
                          <button onClick={handleShortlist}>Shortlist</button>
                        </div>
                        <div className="col-12 mb-2">
                          <button onClick={handleCallback}>Call Back</button>
                        </div>
                        <div className="col-12 mb-2">
                          <button onClick={handleSendBAFO}>Send BAFO</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "queries" && (
              <div className="tab-content active">
                <div className="row">
                  <div className="col-lg-10 col-sm-9 col-12">
                    <table>
                      <thead>
                        <tr>
                          <th>Query Date</th>
                          <th>Query</th>
                          <th>Reply Date</th>
                          <th>Reply</th>
                        </tr>
                      </thead>
                      <tbody>
                        {queries.map((query) => (
                          <tr
                            key={query.QueryID}
                            onClick={() => handleQueryRowClick(query)}
                            className={
                              selectedQuery &&
                              selectedQuery.QueryID === query.QueryID
                                ? "selected"
                                : ""
                            }
                          >
                            <td>{query.QueryDate}</td>
                            <td>{query.QueryDescription}</td>
                            <td>{query.QueryReplyDate}</td>
                            <td>{query.QueryReply}</td>
                          </tr>
                        ))}
                        {queries.length === 0 && (
                          <tr>
                            <td colSpan="4">No queries available</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className="col-lg-2 col-sm-3 col-12">
                    <div className="actions">
                      <button
                        disabled={
                          selectedBuyerItemDetail === undefined ||
                          selectedBuyerItemDetail === null
                        }
                        onClick={() => {
                          setShowRaiseQueryModal(true);
                        }}
                      >
                        Raise Query
                      </button>
                    </div>
                  </div>
                </div>
                <div className="pagination">
                  <button
                    onClick={() => handleQueryPageChange(queryPage - 1)}
                    disabled={queryPage === 1}
                  >
                    {"<"}
                  </button>
                  {Array.from({ length: queryTotalPages }, (_, index) => (
                    <button
                      key={index + 1}
                      onClick={() => handleQueryPageChange(index + 1)}
                      className={queryPage === index + 1 ? "active" : ""}
                    >
                      {index + 1}
                    </button>
                  ))}
                  <button
                    onClick={() => handleQueryPageChange(queryPage + 1)}
                    disabled={queryPage === queryTotalPages}
                  >
                    {">"}
                  </button>
                </div>
              </div>
            )}
          </section>
        </main>

        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Message</Modal.Title>
          </Modal.Header>
          <Modal.Body>{showModalMsg}</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showRaiseQueryModal}
          onHide={() => setShowRaiseQueryModal(false)}
          backdrop="static"
          className="modal-raisequery"
        >
          <Modal.Header closeButton>
            <Modal.Title>Raise Query</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-12">
                <textarea
                  placeholder="Enter Query Description"
                  className="form-control mb-2"
                  value={queryDescription}
                  onChange={(e) => setQueryDescription(e.target.value)}
                ></textarea>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleCreateQuery}>
              Raise Query
            </Button>
            <Button
              variant="secondary"
              onClick={() => setShowRaiseQueryModal(false)}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default BuyerDashboard;
